import { createApiActionTypes } from 'store';

export const POST_NEW_CLIENT = createApiActionTypes('POST_NEW_CLIENT');
export const GET_CLIENT_LIST = createApiActionTypes('GET_CLIENT_LIST');
export const UPDATE_CLIENT_LIST = createApiActionTypes('UPDATE_CLIENT_LIST');

export const GET_CLIENT_DETAILS = createApiActionTypes('GET_CLIENT_DETAILS');
export const DELETE_CLIENT = createApiActionTypes('DELETE_CLIENT');

export const GET_CLIENT_DATA = createApiActionTypes('GET_CLIENT_DATA');
export const UPDATE_CLIENT_DATA = createApiActionTypes('UPDATE_CLIENT_DATA');

export const GET_CLIENT_USERS = createApiActionTypes('GET_CLIENT_USERS');
export const GET_PARTNER_LIMITS = createApiActionTypes('GET_PARTNER_LIMITS');

export const GET_CLIENT_SURVEY_DATA = createApiActionTypes(
	'GET_CLIENT_SURVEY_DATA',
);
export const CREATE_CLIENT_USER = createApiActionTypes('CREATE_CLIENT_USER');

export const RESET_CLIENT_LIST = 'RESET_CLIENT_LIST';
export const RESET_NEW_CLIENT = 'RESET_NEW_CLIENT';
export const RESET_CLIENT_DETAILS = 'RESET_CLIENT_DETAILS';
export const RESET_CLIENT_ERROR = 'RESET_CLIENT_ERROR';
export const RESET_CLIENT_DATA = 'RESET_CLIENT_DATA';
export const RESET_UPDATE_CLIENT_DATA = 'RESET_UPDATE_CLIENT_DATA';
export const RESET_CLIENT_NEW_USER = 'RESET_CLIENT_NEW_USER';
export const RESET_IS_CLIENT_DELETED = 'RESET_IS_CLIENT_DELETED';
